import React from 'react';
import { Flex, Spin, SpinProps } from 'antd';
import classNames from 'classnames';
import { css } from 'styled-components';

const styles = {
  spin: css`
    flex: 1;
    min-width: 40px;

    &:not(.dev-ex-spinner-small) {
      min-height: 72px;
    }

    &:has(.ant-spin-text) {
      min-height: 92px;
    }

    .ant-spin-nested-loading {
      flex: 1;

      .ant-spin {
        &:has(.ant-spin-text) {
          .ant-spin-dot {
            margin-top: -32px;
          }
        }

        .ant-spin-dot-item {
          background-color: ${(props) => props.theme.color.brand.default};
        }

        .ant-spin-text {
          text-shadow: none;
          font-size: ${(props) => props.theme.variable.fontSize.sm};
          color: ${(props) => props.theme.color.text.secondary};
        }
      }
    }
  `,
};

interface DevExLoaderProps extends SpinProps {}

export const DevExLoader: React.FC<DevExLoaderProps> = (props) => {
  const classes = classNames({
    'dev-ex-spinner-small': props.size && props.size === 'small',
  });
  return (
    <Flex align="center" justify="center" css={styles.spin} className={classes}>
      <Spin size="large" {...props}>
        {/* props.tip will only appear if Spin has a child */}
        {props.children ?? <div />}
      </Spin>
    </Flex>
  );
};
